import { render, staticRenderFns } from "./HubContent.vue?vue&type=template&id=31e9932c&scoped=true"
import script from "./HubContent.vue?vue&type=script&lang=ts"
export * from "./HubContent.vue?vue&type=script&lang=ts"
import style0 from "./HubContent.vue?vue&type=style&index=0&id=31e9932c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e9932c",
  null
  
)

export default component.exports